import api from "../../api/api";
import LocalStorage from "../../utils/LocalStorage";
import {clearAuthStorage, LOCAL_STORAGE_ITEMS} from "../../constants";
import {
    Add_Multi_Address,
    CHECK_USERNAME,
    Edit_User_Setting,
    File_Upload,
    Forget_Password_By_User,
    Forget_Password_URL,
    Get_Email_Code_Forget_Password,
    Get_Email_Code_Sign_Up,
    Get_Email_Code_Verify,
    Get_Multi_Address_List,
    Get_User_Setting,
    Get_Routes,
    IsAdmin_URL,
    LOG_IN,
    LOG_OUT,
    Modify_Multi_Address,
    Refresh,
    REGISTER,
    Remove_Multi_Address,
    Reset_Password,
    VERIFICATION_URL,
    Fetch_User_Info,
    Edit_User_Setting_Email,
    Menu_List_By_Role,
    Get_Email_Code_Sign_In,
    Get_Sign_In_Email_Code_Verify, Notification_Banner, Get_Quickbooks_Flag, REGISTER_v2
} from "../../config";
import { noop } from "lodash";
import axios from "axios";
import {check_have_card, sub_user_owner_name, SystemActionType} from "../system/systemAction";
import {convertRoutes, extractKeys, filterRoutes} from "../../utils/globalFunction";
import adminRoutes from "../../adminRoutes";
import {checkPermission, PERMISSION_DICT, ROLES_MAPPER, USER_ROLES} from "../../utils/Users_Roles_Permission";
import {current} from "@reduxjs/toolkit";


export const AuthActionType = {
    Login: 'AuthLogin',
    Logout: 'AuthLogout',
    AuthCheck: 'AuthCheck',
    AuthError: 'AuthError',
    FetchMenu: 'FetchMenu',
    FunctionCheck: 'FunctionCheck',
    FetchUserRole: 'FetchUserRole',
    FetchNavi: 'FetchBreadNav',
    AuthUser: 'AuthUser',
    FetchVerification:'FetchVerification',
    UserSetting:'UserSetting',
    MultiAddressList:'MultiAddressList',
    CHANGE_LOADING:'CHANGE_LOADING',
    Get_Routes:'Get_Routes',
    Set_Current_Routes:'Set_Current_Routes',
    Permissions:'Permissions',
    Roles_List:'Roles_List',
    User_Type:'User_Type'


};

// default it will send token to server from localstorage, when token expires before 8hours ,
// server will send a new token , then replace the localstorage and api token



export const Logout = (onSuccess) => async (dispatch) => {

    try{

        const url = `${LOG_OUT}`

        const response = await api.delete(url)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({ type: AuthActionType.Logout })
            clearAuthStorage()
            onSuccess('Log out successfully')

        }
    }catch (e) {
        dispatch({ type: AuthActionType.Logout })
        window.open('/', '_self');
    }

};


export const setCurrentRoutes = (routes)=> (dispatch) => {
    dispatch({
        type:AuthActionType.Set_Current_Routes,
        payload:routes
    })
}

export const get_notification = (onSuccess = noop, onError = noop) => async (dispatch) =>  {
    try {
        const url = `${Notification_Banner}`
        // if(!Boolean(LocalStorage.getItem('notification'))){
        //     onSuccess(null)
        // }
        const response = await api.get(url)
            .then(res => res)
        if(response?.status === 200 && response.data.code === 200){
            if(response.data.data){
                if(response.data.data?.notificationInfo !== null){
                    onSuccess(response.data.data?.notificationInfo)
                } else {
                    onSuccess({inactive:true})
                }

            }

        } else {
            onError(response?.data?.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const get_auth_info = (onSuccess = noop, onError = noop) => async (dispatch) => {
    try{

        // const url2 = `${Menu_List_By_Role}`
        // const response2 = await api.post(url2, {roleIds:[102]})
        //     .then(res=>res)

        const url = `${Fetch_User_Info}`
        const response = await api.get(url)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){


            if(response?.data?.user?.userType === ROLES_MAPPER.CUSTOMER){
                dispatch({
                    type:AuthActionType.User_Type,
                    payload:'customer'
                })
                LocalStorage.setItem('role','customer')
            } else if(response?.data?.user?.userType === ROLES_MAPPER.ADMIN){
                dispatch({
                    type:AuthActionType.User_Type,
                    payload:'admin'
                })
                LocalStorage.setItem('role','admin')
            } else {
                dispatch({
                    type:AuthActionType.User_Type,
                    payload:'sub_customer'
                })

                LocalStorage.setItem('role','sub_customer')
            }

            if(response?.data?.user?.userType === ROLES_MAPPER.CUSTOMER || response?.data?.user?.userType === ROLES_MAPPER.ADMIN){
                LocalStorage.setItem('username',response?.data?.user?.userName)
                LocalStorage.setItem('sub_username',response?.data?.user?.userName)
            } else if(response?.data?.user?.userType === ROLES_MAPPER.SUB_CUSTOMER){
                const axiosGet = async () => {
                    await dispatch(sub_user_owner_name((name)=>{
                        LocalStorage.setItem('username',name)
                        LocalStorage.setItem('sub_username',response?.data?.user?.userName)
                    },onError))
                }

                axiosGet().then()

            }


            dispatch({
                type:AuthActionType.Roles_List,
                payload:response.data?.roles
            })
            if(response.data?.roles.includes(USER_ROLES.CUSTOMER)){
                LocalStorage.setItem('role','customer')
            }
            //ocp管理员
            if(response.data?.roles.includes(USER_ROLES.DAR_ADMIN)){
                LocalStorage.setItem('role','admin')
            }
            //ocp超级管理员
            if(response.data?.roles.includes(USER_ROLES.DAR_SUPER_ADMIN)){
                LocalStorage.setItem('role','admin')
            }
            //超级管理员
            if(response.data?.roles.includes(USER_ROLES.ADMIN)){
                LocalStorage.setItem('role','admin')
            }
            //会计
            if(response.data?.roles.includes(USER_ROLES.DAR_ACCOUNTING)){
                LocalStorage.setItem('role','admin')
            }


            LocalStorage.setItem('user_roles',JSON.stringify(response.data?.roles))
            dispatch({
                type:AuthActionType.Permissions,
                payload:response.data?.permissions
            })
            LocalStorage.setItem('permissions',JSON.stringify(response.data?.permissions))
            //check admin or customer
            if(response.data?.permissions && response.data?.permissions.includes(PERMISSION_DICT.AccessCheckCreditCard)){
                const axiosGet = async () => {

                    let formData ={}
                    // formData.ownerId = LocalStorage.getItem('ownerId')
                    await dispatch(check_have_card(formData,onSuccessfully,onError))
                }

                const onSuccessfully = (status) => {
                    dispatch({
                        type:AuthActionType.CHANGE_LOADING,
                        payload:false
                    })

                    onSuccess('customer',status)
                }
                axiosGet().then()
            } else {
                dispatch({
                    type:SystemActionType.Check_Card,
                    payload:true
                })
                onSuccess('admin',true)
            }
        } else {
            onError(response?.data?.msg)

        }


    }catch (e) {
        onError(e.message)

    }
}


export const get_routes = (onSuccess = noop, onError = noop) => async (dispatch) => {
    try{


        const url = `${Get_Routes}`
        const response = await api.get(url)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:AuthActionType.Get_Routes,
                payload:response.data.data
            })
            onSuccess()
        } else {
            onError(response?.data?.msg)

        }


    }catch (e) {
        onError(e.message)

    }
}




export const loginCodeVerify = (data,onSuccess = noop, onError = noop) => async (dispatch) => {
    try{
        const url = `${Get_Sign_In_Email_Code_Verify}`
        const response = await api.post(url, {...data})
            .then(res=>res)
        if (response?.status === 200 && response.data.code === 200) {
            onSuccess('Log in successfully')
        }else{
            onError(response.data.msg)
        }
    }catch (e) {
        onError(e.message)
    }

}

export const getEmailCodeSignIn = (data,onSuccess = noop, onError = noop) => async (dispatch) => {
    try{
        const url = `${Get_Email_Code_Sign_In}`
        const response = await api.get(url, {params:{emailAddress:data?.email}} ).then(res=>res)
        if (response?.status === 200 && response.data.code === 200) {
            onSuccess()
        }else{
            onError(response.data.msg)
        }
    }catch (e) {
        onError(e.message)
    }

}



export const authLogin = (data,onSuccess = noop, onError = noop) => async (dispatch) => {
  try{

      const url = `${LOG_IN}`
      const response = await api.post(url, {...data})
          .then(res=>res)
      //dispatch({ type: AuthActionType.Login, payload: response.data });
      if (response?.status === 200 && response.data.code === 200) {
          LocalStorage.setItem(LOCAL_STORAGE_ITEMS.token, response.data?.data?.access_token);
          response.data?.data?.ownerId && LocalStorage.setItem(LOCAL_STORAGE_ITEMS.ownerId , response.data?.data?.ownerId)
          onSuccess(response.data?.data)
      }else{
          // if(response.data.code === 500){
              // dispatch(getVerificationCode())
          // }
          onError(response?.data?.msg)
      }
  }catch (e) {
      onError(e.message)
  }

}

export const authRegister = (data,onSuccess = noop, onError = noop) => async (dispatch) => {

    try{
        let url = ""
        if (data?.userInfo?.oldUserFlag === 'Y') {
            url = `${process.env.REACT_APP_BASE_URL}${REGISTER}`
        }else {
            url = `${process.env.REACT_APP_BASE_URL}${REGISTER_v2}`
        }

        const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':'en'
        const instance = axios.create({
            baseURL: url,
            timeout: 10000, // 设置超时时间为10秒
            headers:{
                'Accept': 'application/json',
                'Language': lang
            }
        });
        const response = await instance.post(url, {...data})
            .then(res=>res)
        if (response?.status === 200 && response?.data?.code === 200) {
            onSuccess('SignUpPage.Register successfully')
        } else {
            if(response.data.msg.includes("注册账号已存在")){
                const match = response.data.msg.match(/注册用户(\w+)失败/);
                if (match) {
                    const username = match[1];
                    onError(`Username ${username} already exists, please change another one`,username)
                    return null
                } else {
                    onError('SignUpPage.User already exists')
                }
            } else {
                onError(response?.data?.msg)
            }

        }

    } catch (e) {
        onError(e.message)
    }


}

export const refreshAccessToken = (onSuccess = noop, onError = noop) => async dispatch => {
  try{
    const url = `${Refresh}`
    const res = await api.post(url);

  } catch (e) {
    onError(e.message)
  }
}

export const getVerificationCode = (onSuccess = noop,onError = noop) => async dispatch => {
  const url = `${process.env.REACT_APP_BASE_URL}${VERIFICATION_URL}`
    try {
        const response = await axios.get(url).then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:AuthActionType.FetchVerification,
                payload:response.data
            })
            onSuccess(response.data)
        } else {
            onError(response.data.msg)
        }
    } catch (e){
        onError(e.message)
    }

}



export const isAdmin = (data,onSuccess = noop,onError = noop) => async dispatch => {

    try{
        dispatch({
            type:AuthActionType.CHANGE_LOADING,
            payload:true
        })

        const url = `${IsAdmin_URL}`
        const response = await api.post(url,data).then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            LocalStorage.setItem('role','admin')
            dispatch({
                type:AuthActionType.FetchUserRole,
                payload:'admin'
            })
            dispatch({
                type:SystemActionType.Set_Card,
                payload:true
            })
            onSuccess('admin',true)
            dispatch({
                type:AuthActionType.CHANGE_LOADING,
                payload:false
            })
        } else if(response?.status === 200 && response.data.code === 500 ){
            LocalStorage.setItem('role','customer')
            dispatch({
                type:AuthActionType.FetchUserRole,
                payload:'customer'
            })

            const axiosGet = async () => {

                let formData ={}
                // formData.ownerId = LocalStorage.getItem('ownerId')
                //formData.username = LocalStorage.getItem('username')
                await dispatch(check_have_card(formData,onSuccessfully,onError))
                //await dispatch(check_default_card(formData,onSuccessfully,onError))
            }

            const onSuccessfully = (status) => {
                dispatch({
                    type:AuthActionType.CHANGE_LOADING,
                    payload:false
                })

                onSuccess('customer',status)
            }
            axiosGet().then()

        } else {
            onError(response.data.msg)
        }

    }catch (e) {
        onError(e.message)
    }

}

export const forgetPassword = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try{
        const url = `${process.env.REACT_APP_BASE_URL}${Forget_Password_URL}`
        const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':'en'
        const instance = axios.create({
            baseURL: url,
            timeout: 5000, // 设置超时时间为3秒
            headers:{
                'Accept': 'application/json',
                'Language': lang
            }
        });
        const response = await instance.post(url,data).then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data)
        } else {
            onError(response.data.msg)
        }
    } catch (e) {
        onError(e.message)
    }

}

export const forgetPasswordByUser = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try{
        const url = `${process.env.REACT_APP_BASE_URL}${Forget_Password_By_User}`
        const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':'en'
        const instance = axios.create({
            baseURL: url,
            timeout: 5000, // 设置超时时间为3秒
            headers:{
                'Accept': 'application/json',
                'Language': lang
            }
        });
        const response = await instance.post(url,data).then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data)
        } else {
            onError(response.data.msg)
        }
    }
    catch (e) {
       onError(e.message)
    }

}

export const getEmailCode =  (email,onSuccess = noop,onError = noop) => async dispatch => {
  try{
      const url = `${process.env.REACT_APP_BASE_URL}${Get_Email_Code_Sign_Up}`
      const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':'en'
      const instance = axios.create({
          baseURL: url,
          timeout: 5000, // 设置超时时间为3秒
          headers:{
              'Accept': 'application/json',
              'Language': lang
          }
      });
      const response = await instance.get(url, {params:{emailAddress:email}} ).then(res=>res)
      if(response?.status === 200 && response.data.code === 200){
          onSuccess(response.data)
      } else {
          onError(response.data.msg)
      }

  }
  catch (e) {
      onError(e.message)
  }

}

export const getEmailCodeForForgetPW = (email,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        const url = `${process.env.REACT_APP_BASE_URL}${Get_Email_Code_Forget_Password}`
        const lang = LocalStorage.getItem('i18nextLng') === 'zh'?'zh':'en'
        const instance = axios.create({
            baseURL: url,
            timeout: 5000, // 设置超时时间为3秒
            headers:{
                'Accept': 'application/json',
                'Language': lang
            }
        });
        const response = await instance.get(url, {params:{emailAddress:email}} ).then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data)
        } else {
            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }


}

export const getEmailCodeVerify =  (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        const url = `${process.env.REACT_APP_BASE_URL}${Get_Email_Code_Verify}`
        const response = await axios.post(url,data).then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data)
        } else {
            onError(response?.data.msg)
        }
    } catch (e) {
        onError(e.message)
    }


}

export const checkUsername = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try{
        const url = `${process.env.REACT_APP_BASE_URL}${CHECK_USERNAME}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg)
        }
    }catch (e) {
        onError(e.message)
    }
}


export const changePassword = (data,onSuccess = noop, onError = noop) => async (dispatch) => {
    try{

        if (!checkPermission(PERMISSION_DICT.AccountPasswordModify)) return null;
        const url = `${process.env.REACT_APP_BASE_URL}${Reset_Password}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess("ForgotPasswordPage.Password Changed Successfully")
        } else {
            onError(response.data.msg)
        }
    }catch (e) {
        onError(e.message)
    }
}




export const getUserSetting = (onSuccess = noop,onError = noop) => async dispatch => {
    if (!checkPermission(PERMISSION_DICT.AccountDataList)) return null;

    const url = `${process.env.REACT_APP_BASE_URL}${Get_User_Setting}` + 'info?userName=' +`${localStorage.getItem('username')}`
    try {


        const response = await api.get(url).then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:AuthActionType.UserSetting,
                payload:response.data
            })
            onSuccess(response.data)
        } else {
            onError(response.data.msg)
        }
    } catch (e){
        onError(e.message)
    }

}

export const editEmailSetting = ( data,onSuccess = noop,onError = noop) => async dispatch => {

    if (!checkPermission(PERMISSION_DICT.AccountEmailModify)) return null;
    const url = `${process.env.REACT_APP_BASE_URL}${Edit_User_Setting_Email}`
    try {
        const response = await api.post(url, {...data}).then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("AccountPage.Email Address Changed Successfully")
        } else {
            onError(response.data.msg)
        }
    } catch (e){
        onError(e.message)
    }

}


export const editUserSetting = (data,onSuccess = noop,onError = noop) => async dispatch => {
    if (!checkPermission(PERMISSION_DICT.AccountProfileModify)) return null;
    const url = `${process.env.REACT_APP_BASE_URL}${Edit_User_Setting}`
    try {

        const response = await api.post(url, {...data}).then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess("AccountPage.Edit User Info Successfully")
        } else {
            onError(response.data.msg)
        }
    } catch (e){
        onError(e.message)
    }
}

// export const fileUpload = (data,onSuccess = noop,onError = noop) => async dispatch => {
//     const url = `${process.env.REACT_APP_BASE_URL}${File_Upload}`
//     try {
//         const response = await api.post(url, {...data}).then(res=>res)
//
//         if(response?.status === 200 && response.data.code === 200){
//             onSuccess(response.data.url)
//         } else {
//             onError(response.data.msg)
//         }
//     } catch (e){
//         onError(e.message)
//     }
// }

export const getMultiAddressList = (data,onSuccess = noop,onError = noop) => async dispatch => {

    if (!checkPermission(PERMISSION_DICT.AccountMultiAddressList)) return null;
    const url = `${process.env.REACT_APP_BASE_URL}${Get_Multi_Address_List}`
    try {
        const response = await api.post(url, {...data}).then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:AuthActionType.MultiAddressList,
                payload:response.data
            })
            onSuccess(response.data)
        } else {
            onError(response.data.msg)
        }
    } catch (e){
        onError(e.message)
    }

}

export const addMultiAddress = (data,onSuccess = noop,onError = noop) => async dispatch => {

    if (!checkPermission(PERMISSION_DICT.AccountMultiAddressAdd)) return null;
    const url = `${process.env.REACT_APP_BASE_URL}${Add_Multi_Address}`
    try {
        const response = await api.post(url, {...data}).then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess("AccountPage.Add Address Info Successfully")
        } else {
            onError(response.data.msg)
        }
    } catch (e){
        onError(e.message)
    }

}


export const removeMultiAddress = (data,onSuccess = noop,onError = noop) => async dispatch => {
    if (!checkPermission(PERMISSION_DICT.AccountMultiAddressDelete)) return null;

    const url = `${process.env.REACT_APP_BASE_URL}${Remove_Multi_Address}`
    try {
        const response = await api.post(url, {...data}).then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess("Remove Address Info Successfully")
        } else {
            onError(response.data.msg)
        }
    } catch (e){
        onError(e.message)
    }

}


export const modifyMultiAddress = (data,onSuccess = noop,onError = noop) => async dispatch => {

    if (!checkPermission(PERMISSION_DICT.AccountMultiAddressModify)) return null;
    const url = `${process.env.REACT_APP_BASE_URL}${Modify_Multi_Address}`
    try {
        const response = await api.post(url, {...data}).then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess("AccountPage.Edit Address Info Successfully")
        } else {
            onError(response.data.msg)
        }
    } catch (e){
        onError(e.message)
    }

}

export const get_quickbooks_flag = (onSuccess = noop, onError = noop) => async (dispatch) =>  {
    try {
        const url = `${process.env.REACT_APP_BASE_URL}${Get_Quickbooks_Flag}`
        const response = await api.get(url)
            .then(res => res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess(response?.data?.data)
        } else {
            onError(response?.data?.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}





